<div class="wrapper-abandoned-list" [class.embedded]="embedded">
  <div class="section-title" *ngIf="!embedded">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <div class="title">{{ "Abandoned Carts" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="checkout-toolbar mb-4" [class.is-collapsed]="!toolbarOpen">
    <div class="filter-options" id="cartFilterOptions">
      <!-- Date Filter Dropdown -->
      <div ngbDropdown #dateDropdown="ngbDropdown" class="d-inline-block">
        <button
          class="btn btn-filter"
          [class.active]="dateFilter && dateFilter.value !== 'cm'"
          id="dropdownDateFilter"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-calendar mr-1"></i>
          <span>
            {{ (date.type?.display | translate) || (dateFilter?.display | translate) || ("Order Date" | translate) }}
          </span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownDateFilter" class="custom-dropdown p-2" style="min-width: 260px;">
          <button ngbDropdownItem *ngFor="let filter of DATE_FILTERS" [disabled]="filter.selectable"
            (click)="dateUpdated(filter)">
            {{ filter.display | translate }}
          </button>
          <div class="dropdown-divider"></div>
          <div class="px-2 date-range-picker">
            <p class="mb-2 font-weight-bold text-xs">{{ "Select a date range" | translate }}:</p>
            <ngb-datepicker #dp (dateSelect)="onDateSelection($event)" [displayMonths]="1"
              [minDate]="this.minDate" [maxDate]="this.maxDate" [dayTemplate]="t" outsideDays="hidden">
            </ngb-datepicker>

            <ng-template #t let-date let-focused="focused">
              <div class="custom-day-container" [class.focused]="focused" [class.start-day]="date == fromDate"
                [class.end-day]="date == toDate" [class.range]="isRange(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                (mouseleave)="hoveredDate = null">
                <span class="custom-day">{{ date.day }}</span>
              </div>
            </ng-template>
            <div class="py-2 text-right">
              <button type="button" class="btn btn-date-range cancel mr-1" (click)="dateDropdown.close()">
                {{ "Cancel" | translate }}
              </button>
              <button type="button" class="btn btn-date-range" [disabled]="!fromDate || !toDate"
                (click)="dateDropdown.close(); setDueDate()">
                {{ "Apply" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Platform and source; status is the tabs above the list -->
      <div ngbDropdown #moreFilters="ngbDropdown" class="d-inline-block" autoClose="outside" placement="bottom-left bottom-right">
        <button
          type="button"
          class="btn btn-filter btn-more-filters"
          [class.active]="moreFilterCount > 0"
          id="dropdownCartMoreFilters"
          ngbDropdownToggle
        >
          <i class="fi fi-rr-settings-sliders mr-1"></i>
          <span>{{ "More filters" | translate }}</span>
          <span class="filter-count" *ngIf="moreFilterCount > 0">{{ moreFilterCount }}</span>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownCartMoreFilters" class="more-filters-menu">
          <section class="filter-group" *ngIf="showFilterGroup(platformTypeFilters, selectedPlatformType)">
            <h5 class="filter-group-title" id="filterCartPlatform">{{ "Platform" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterCartPlatform">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of platformTypeFilters"
                [class.active]="isSelectedFilter(selectedPlatformType, filter)"
                [attr.aria-checked]="isSelectedFilter(selectedPlatformType, filter)"
                (click)="selectedPlatformType = filter; page = 1"
              >
                {{ filter.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>

          <section class="filter-group" *ngIf="showFilterGroup(orderTypeFilters, selectedOrderType)">
            <h5 class="filter-group-title" id="filterCartSource">{{ "Source" | translate }}</h5>
            <div class="filter-chips" role="radiogroup" aria-labelledby="filterCartSource">
              <button
                type="button"
                role="radio"
                class="filter-chip"
                *ngFor="let filter of orderTypeFilters"
                [class.active]="isSelectedFilter(selectedOrderType, filter)"
                [attr.aria-checked]="isSelectedFilter(selectedOrderType, filter)"
                (click)="selectedOrderType = filter; page = 1"
              >
                {{ filter.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(filter.display)]) }}
              </button>
            </div>
          </section>

          <div class="more-filters-footer">
            <button type="button" class="btn filter-clear" [disabled]="moreFilterCount === 0" (click)="clearMoreFilters()">
              {{ "Clear" | translate }}
            </button>
            <button type="button" class="btn btn-primary filter-done" (click)="moreFilters.close()">
              {{ "Done" | translate }}
            </button>
          </div>
        </div>
      </div>

      <!-- Export Button -->
      <button
        type="button"
        class="btn btn-filter btn-export-excel"
        [disabled]="!filteredCartHistoryList.length"
        (click)="export('csv')"
        title="{{ 'Export to Excel' | translate }}"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1.5 flex-shrink-0">
          <path fill="#107C41" d="M14 2H6C4.89 2 4 2.89 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2Z"/>
          <path fill="#FFFFFF" opacity="0.6" d="M14 2L20 8H14V2Z"/>
          <path fill="#FFFFFF" d="M9.6 16.5L11.5 13.6L13.4 16.5H15.5L12.6 12.3L15.3 8.5H13.2L11.5 11L9.8 8.5H7.7L10.4 12.3L7.5 16.5H9.6Z"/>
        </svg>
        <span class="text-[#107C41] font-weight-medium">{{ "Export Excel" | translate }}</span>
      </button>
    </div>

    <!-- Search; on phones the filters above fold behind the Filters button beside it -->
    <div class="toolbar-end">
      <div class="search-box">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="email"
          (change)="searchEmail($event)"
          (keyup.enter)="searchEmail($event)"
          placeholder="{{ 'Search Email' | translate }}"
        />
        <i class="fi fi-rr-search search-icon"></i>
        <i class="fas fa-times clear-icon" *ngIf="email" (click)="clearAbandonedCartSearch()"></i>
      </div>
      <button
        type="button"
        class="btn toolbar-toggle"
        [class.active]="toolbarFilterCount > 0"
        [class.is-open]="toolbarOpen"
        [attr.aria-expanded]="toolbarOpen"
        aria-controls="cartFilterOptions"
        (click)="toolbarOpen = !toolbarOpen"
      >
        <i class="fi fi-rr-filter" aria-hidden="true"></i>
        <span>{{ "Filters" | translate }}</span>
        <span class="filter-count" *ngIf="toolbarFilterCount > 0">{{ toolbarFilterCount }}</span>
        <i class="fi fi-rr-angle-small-down toggle-chevron" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <div class="section-main">
    <div class="row" *ngIf="dataIsLoading; else loadedContent">
      <div class="loading-spinner col-12 mt-5">
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <ng-template #loadedContent>
      <div class="orders-panel carts-panel">
        <!-- Status: one tab per status, each with its cart count -->
        <div class="status-tabs" role="tablist" [attr.aria-label]="'Status' | translate" *ngIf="allCarts?.length">
          <button
            type="button"
            role="tab"
            class="status-tab"
            *ngFor="let tab of statusTabs"
            [class.active]="isSelectedFilter(selectedStatus, tab.option)"
            [class.is-zero]="!tab.count"
            [attr.aria-selected]="isSelectedFilter(selectedStatus, tab.option)"
            (click)="selectStatusTab(tab.option)"
          >
            <span>
              {{ tab.option.value === "ALL" ? ("All" | translate) : ("{0}" | translate : [utils.translate(tab.option.display)]) }}
            </span>
            <span class="status-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <div class="orders-empty" *ngIf="!filteredCartHistoryList.length">
          <img class="orders-empty-image" src="/assets/empty-cart.png" alt="" />
          <h3>{{ "No Abandon Cart Found" | translate }}</h3>
          <p>
            {{ "We couldn't find any abandon cart data for the selected filter." | translate }}
            <br />
            {{ "Try change the filter?" | translate }}
          </p>
        </div>

        <ng-container *ngIf="filteredCartHistoryList.length">
          <div class="orders-head" aria-hidden="true">
            <span>{{ "Customer" | translate }}</span>
            <span>{{ "Time created" | translate }}</span>
            <span>{{ "Cart" | translate }}</span>
            <span>{{ "Status" | translate }}</span>
            <span></span>
          </div>

          <div class="order-row" *ngFor="let data of filteredCartHistoryList" (click)="openCartFromRow(content, data)">
            <!-- Who left the cart -->
            <div class="order-cell cart-customer">
              <button
                type="button"
                class="cart-email"
                [attr.aria-label]="'View Cart Details' | translate"
                (click)="$event.stopPropagation(); openCart(content, data)"
              >
                {{ data.customer_email || data.customer_mobile || ("No email" | translate) }}
              </button>
              <span class="cart-meta" *ngIf="data.customer_email && data.customer_mobile">
                <i class="fi fi-rr-phone-call" aria-hidden="true"></i>
                {{ data.customer_mobile }}
              </span>
            </div>

            <div class="order-cell cart-created">
              <span
                class="cart-time"
                #tooltip="matTooltip"
                [matTooltip]="data.created_at | date : 'medium'"
                matTooltipPosition="above"
                matTooltipHideDelay="100"
              >
                {{ data.created_at | timeago : true }}
              </span>
              <span class="cart-meta">{{ data.created_at | date : "d MMM y, h:mm a" }}</span>
            </div>

            <!-- What was in it -->
            <div class="order-cell cart-items">
              <span class="cart-count" *ngIf="data.cart?.length">
                {{ data.cart.length === 1 ? ("1 item" | translate) : ("{0} items" | translate : [data.cart.length]) }}
              </span>
              <span class="cart-meta" *ngIf="!data.cart?.length">-</span>
              <span class="platform-tag" *ngIf="getOrderType(data.platform)?.display !== 'Default'">
                {{ getOrderType(data.platform)?.display | translate }}
              </span>
            </div>

            <div class="order-cell cart-status">
              <span class="status-chip" *ngIf="getCartStatus(data).label" [ngClass]="getCartStatus(data).class">
                {{ getCartStatus(data).label | translate }}
              </span>
            </div>

            <!-- Recovery link, session replay, resolve / discard, open -->
            <div class="order-cell order-actions" (click)="$event.stopPropagation()">
              <button
                *ngIf="data.status_id === '0'"
                type="button"
                class="btn row-btn row-icon"
                (click)="openLink(linkModal, data)"
                matTooltip="{{ 'Express Checkout Link' | translate }}"
                matTooltipPosition="above"
                [attr.aria-label]="'Express Checkout Link' | translate"
              >
                <i class="fi fi-rr-link" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="data.session_id"
                type="button"
                class="btn row-btn row-icon"
                (click)="watchSessionFromList(data)"
                matTooltip="{{ 'Watch Session Recording' | translate }}"
                matTooltipPosition="above"
                [attr.aria-label]="'Watch Session Recording' | translate"
              >
                <i class="fi fi-rr-play-alt" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="data.status_id === '0'"
                type="button"
                class="btn row-btn row-icon row-icon-success"
                (click)="updateStatus(2, data)"
                matTooltip="{{ 'Mark as Resolved' | translate }}"
                matTooltipPosition="above"
                [attr.aria-label]="'Mark as Resolved' | translate"
              >
                <i class="fi fi-rr-check" aria-hidden="true"></i>
              </button>
              <button
                *ngIf="data.status_id === '0'"
                type="button"
                class="btn row-btn row-icon row-btn-danger"
                (click)="updateStatus(8, data)"
                matTooltip="{{ 'Mark as Discarded' | translate }}"
                matTooltipPosition="above"
                [attr.aria-label]="'Mark as Discarded' | translate"
              >
                <i class="fi fi-rr-trash" aria-hidden="true"></i>
              </button>
              <button
                type="button"
                class="row-open"
                [attr.aria-label]="'View Cart Details' | translate"
                [title]="'View Cart Details' | translate"
                (click)="openCart(content, data)"
              >
                <i class="fi fi-rr-angle-small-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="row px-4 py-3 pagination" *ngIf="finalList?.length != 0">
        <div class="col-lg-3 flex">
          <ngb-pagination
            [collectionSize]="finalList.length"
            [(page)]="page"
            [pageSize]="selectedPage"
            aria-label="Default pagination"
            (pageChange)="changePage($event)"
            [maxSize]="5"
          ></ngb-pagination>
        </div>
        <div class="col-lg-3 lg-center paginationWrapper">
          <div class="mt-2 text-center">
            {{ "Showing" | translate }} <b>{{ start + 1 }}–{{ end }}</b> {{ "of" | translate }}
            <b>{{ finalList.length }}</b>
          </div>
        </div>
        <div class="col-lg-4"></div>
      </div>
    </ng-template>
    <ng-template #linkModal let-modal>
      <div class="order-details">
        <div class="od-header">
          <div class="od-heading">
            <h2 class="od-title">{{ "Express Checkout Link" | translate }}</h2>
            <p class="od-ids">
              {{ "Share this recovery link with the customer to quickly complete their purchase" | translate }}
            </p>
          </div>
          <button type="button" class="od-close" [attr.aria-label]="'Close' | translate" (click)="modal.dismiss('Cross click')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor" />
            </svg>
          </button>
        </div>

        <div class="od-body">
          <section class="od-panel" *ngIf="listData?.link; else noRecoveryLink">
            <h3 class="od-panel-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path
                  d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                  fill="currentColor" />
              </svg>
              {{ listData?.language_name || ("Express Checkout" | translate) }}
            </h3>
            <div class="od-payment-link">
              <a class="od-link od-break" [href]="listData?.link" target="_blank">{{ listData?.link }}</a>
              <div class="od-payment-actions">
                <a class="od-btn" target="_blank" [href]="listData?.link"
                  matTooltip="{{ 'Open in new tab' | translate }}" matTooltipPosition="above">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" fill="currentColor" />
                  </svg>
                  <span>{{ "Open" | translate }}</span>
                </a>
                <button type="button" class="od-btn od-btn-primary"
                  (click)="utils.copyToClipboard(listData?.link, 'Express URL')"
                  matTooltip="{{ 'Copy to clipboard' | translate }}" matTooltipPosition="above">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor" />
                  </svg>
                  <span>{{ "Copy" | translate }}</span>
                </button>
              </div>
            </div>
          </section>
          <ng-template #noRecoveryLink>
            <p class="od-muted">{{ "Checkout link not available" | translate }}</p>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #content let-modal>
  <div class="order-details">
    <!-- Header: who left the cart and where it stands -->
    <div class="od-header">
      <div class="od-heading">
        <h2 class="od-title" id="modal-basic-title">{{ "Abandoned Cart Details" | translate }}</h2>
        <p class="od-ids" *ngIf="selectedcarts?.customer_email">
          <span>{{ "Email" | translate }} <strong>{{ selectedcarts?.customer_email }}</strong></span>
        </p>
        <div class="od-status">
          <span class="status-chip" *ngIf="getCartStatus(selectedcarts).label" [ngClass]="getCartStatus(selectedcarts).class">
            {{ getCartStatus(selectedcarts).label | translate }}
          </span>
          <span class="status-chip od-neutral-chip" *ngIf="getOrderType(selectedcarts?.platform)?.display !== 'Default'">
            {{ getOrderType(selectedcarts?.platform)?.display | translate }}
          </span>
        </div>
      </div>
      <button type="button" class="od-close" [attr.aria-label]="'Close' | translate" (click)="modal.dismiss('Cross click')">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor" />
        </svg>
      </button>
    </div>

    <div class="od-body">
      <!-- Key facts -->
      <dl class="od-facts">
        <div class="od-fact od-fact-total">
          <dt>{{ "Items" | translate }}</dt>
          <dd>{{ selectedcarts?.cart?.length || 0 }}</dd>
        </div>
        <div class="od-fact">
          <dt>{{ "Phone Number" | translate }}</dt>
          <dd>{{ selectedcarts?.customer_mobile || "-" }}</dd>
        </div>
        <div class="od-fact">
          <dt>{{ "Time Created" | translate }}</dt>
          <dd>{{ selectedcarts?.created_at | date : "medium" }}</dd>
        </div>
      </dl>

      <div class="od-grid" *ngIf="selectedcarts?.session_id || selectedcarts?.link">
        <!-- Session recording -->
        <section class="od-panel" *ngIf="selectedcarts?.session_id">
          <h3 class="od-panel-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M8 5v14l11-7L8 5z" fill="currentColor" />
            </svg>
            {{ "Session Recording" | translate }}
          </h3>
          <button type="button" class="od-btn od-btn-primary" (click)="watchSession()">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M8 5v14l11-7L8 5z" fill="currentColor" />
            </svg>
            <span>{{ "Watch Session" | translate }}</span>
          </button>
        </section>

        <!-- Recovery link -->
        <section class="od-panel" *ngIf="selectedcarts?.link">
          <h3 class="od-panel-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
                fill="currentColor" />
            </svg>
            {{ "Express Checkout Link" | translate }}
          </h3>
          <a class="od-link od-break" [href]="selectedcarts?.link" target="_blank">{{ selectedcarts?.link }}</a>
          <div class="od-payment-actions od-actions-below">
            <a class="od-btn" target="_blank" [href]="selectedcarts?.link"
              matTooltip="{{ 'Open in new tab' | translate }}" matTooltipPosition="above">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M14 3h7v7h-2V6.41l-9.29 9.3-1.42-1.42 9.3-9.29H14V3zM5 5h6v2H7v10h10v-4h2v6H5V5z" fill="currentColor" />
              </svg>
              <span>{{ "Open" | translate }}</span>
            </a>
            <button type="button" class="od-btn od-btn-primary"
              (click)="utils.copyToClipboard(selectedcarts?.link, 'Express URL')"
              matTooltip="{{ 'Copy to clipboard' | translate }}" matTooltipPosition="above">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" fill="currentColor" />
              </svg>
              <span>{{ "Copy" | translate }}</span>
            </button>
          </div>
        </section>
      </div>

      <!-- Products -->
      <section class="od-panel od-products">
        <h3 class="od-panel-title">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
              d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
              fill="currentColor" />
          </svg>
          {{ "Product Details" | translate }}
          <span class="od-count" *ngIf="selectedcarts?.cart?.length">{{ selectedcarts?.cart?.length }}</span>
        </h3>
        <div class="od-product" *ngFor="let item of selectedcarts?.cart">
          <div class="od-product-main">
            <img [src]="item.product_data.image" class="od-product-image" alt=""
              onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';" />
            <div class="od-product-info">
              <p class="od-product-name">{{ item.product_data.product_name }}</p>
              <p class="od-product-qty">{{ "Qty" | translate }}: {{ item.product_data.quantity }}</p>
            </div>
            <div class="od-product-price">
              <span *ngIf="+item.product_data.price !== 0">
                {{ item.product_data.currency_symbol }} {{ +item.product_data.price | number }}
              </span>
              <span class="od-free" *ngIf="+item.product_data.price === 0">{{ "Free" | translate }}</span>
            </div>
          </div>

          <!-- Mixture products -->
          <div class="od-mixture" *ngIf="item.product_data.mixture_data !== undefined">
            <div class="od-mixture-toggle od-mixture-static">
              <span class="od-mixture-title">{{ "Mixture" | translate }}</span>
            </div>
            <div class="od-mixture-list">
              <div *ngFor="let mixture_product of item.product_data.mixture_data" class="od-mixture-item">
                <img [src]="mixture_product?.product_data?.image" class="od-mixture-image" alt=""
                  onerror="this.onerror=null;this.src='https://cdn.estore5s.com/asset/images/estore_missing_product.png';" />
                <span class="od-mixture-name">{{ mixture_product?.product_data?.product_name }}</span>
                <span class="od-mixture-qty">&times; {{ mixture_product?.quantity }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</ng-template>
